module.exports = __webpack_public_path__ + "media/assets/img/portrait/small/avatar-s-2-fc2135e130e396cfc30cec9b6e9861af.jpg";